const ShipyardUrls = new Map();
const BannerUrls = new Map();
const NationUrls = new Map();
const ShipIconUrls = new Map();
// Filled in by `shiptypes.ts`
const ShiptypeUrls = new Map();

export { ShipyardUrls, BannerUrls, ShiptypeUrls, NationUrls, ShipIconUrls };
